const rawBase = (process.env.REACT_APP_API_URL || '').trim();
const normalisedBase = rawBase.replace(/\/+$/, '');

let baseIsValid = false;
if (normalisedBase) {
  try {
    // Validate base URL includes protocol and hostname
    new URL(normalisedBase);
    baseIsValid = true;
  } catch {
    baseIsValid = false;
  }
}

export const resolveApiUrl = (path: string): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  if (!baseIsValid) {
    return cleanPath;
  }

  const fullUrl = `${normalisedBase}${cleanPath}`;
  return fullUrl;
};

export const apiBase = baseIsValid ? normalisedBase : '';

